import { useEffect, useState } from "react";
import { ArrowUp, MessageCircle, Phone } from "lucide-react";
import { useSite } from "../context/SiteContext";

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  const { brand } = useSite();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed right-4 md:right-6 bottom-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/91${brand.whatsapp}?text=${encodeURIComponent("Hi! I'd like to plan a North East trip.")}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        className="pulse-ring h-12 w-12 grid place-items-center rounded-full bg-emerald-500 text-white shadow-lg hover:scale-105 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href={`tel:+91${brand.phone}`}
        data-testid="floating-call"
        className="h-12 w-12 grid place-items-center rounded-full bg-primary text-primary-foreground shadow-lg hover:scale-105 transition-transform"
        aria-label="Call"
      >
        <Phone className="h-5 w-5" />
      </a>
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="back-to-top"
          aria-label="Back to top"
          className="h-12 w-12 grid place-items-center rounded-full bg-background border border-border shadow-lg hover:scale-105 transition-transform"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
      )}
    </div>
  );
}
